import React from 'react';
import {
    useDispatch, useSelector
} from 'react-redux';

import { AppState } from '../../../../app.types';
import { handleLogoutRedirect } from '../../../../state/effects-middleware/effects';
import {
    SessionTimeoutModalWrapper,
    SessionExpired
} from '../../components';

export const SessionTimeoutModal = () => {
    const state = useSelector<AppState, AppState>((state => state));
    const dispatch = useDispatch();
    const onSignIn = () => {
        handleLogoutRedirect({
            state,
            dispatch
        });
    };

    return (
        <SessionTimeoutModalWrapper>
            <SessionExpired
                onSignIn={onSignIn}
            />
        </SessionTimeoutModalWrapper>
    );
};
